/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum TimeslotSearchCapability {
  DateFrom = 'DateFrom',
  DateTo = 'DateTo',
  TimeFrom = 'TimeFrom',
  TimeTo = 'TimeTo',
  ResourceId = 'ResourceId',
  ResourceSpecialityId = 'ResourceSpecialityId',
  ResourceConditionId = 'ResourceConditionId',
  ResourceUnitId = 'ResourceUnitId'
}
